import { Skeleton } from './Skeleton';
import styles from './UserCardSkeleton.module.scss';

export interface UserCardSkeletonProps {
  /** Number of skeleton cards to render (default: 1) */
  count?: number;
  className?: string;
}

/**
 * Skeleton placeholder matching the exact size and shape of the UserCard component.
 * Renders a row with a 44px avatar circle, two text lines, and a follow button placeholder.
 */
export function UserCardSkeleton({ count = 1, className }: UserCardSkeletonProps) {
  const classes = [styles.wrapper, className].filter(Boolean).join(' ');

  if (count === 1) {
    return (
      <div className={[styles.card, className].filter(Boolean).join(' ')} aria-hidden="true">
        <div className={styles.left}>
          <Skeleton width="44px" height="44px" borderRadius="50%" />
          <div className={styles.textBlock}>
            <Skeleton width="120px" height="0.9rem" borderRadius="4px" />
            <Skeleton width="80px" height="0.7rem" borderRadius="4px" />
          </div>
        </div>
        <Skeleton width="80px" height="32px" borderRadius="var(--radius-md)" />
      </div>
    );
  }

  return (
    <div className={classes} aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={styles.card}>
          <div className={styles.left}>
            <Skeleton width="44px" height="44px" borderRadius="50%" />
            <div className={styles.textBlock}>
              <Skeleton width="120px" height="0.9rem" borderRadius="4px" />
              <Skeleton width="80px" height="0.7rem" borderRadius="4px" />
            </div>
          </div>
          <Skeleton width="80px" height="32px" borderRadius="var(--radius-md)" />
        </div>
      ))}
    </div>
  );
}

export default UserCardSkeleton;
